"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeUtils = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const CalculateUtils_1 = require("./CalculateUtils");
exports.TradeUtils = {
    /**传入某个symbol关联的所有仓位，返回匹配当前仓位方向的正反向仓位*/
    getReversePosition(positions, positionSide, positionMode) {
        let _position;
        let _rPosition;
        if (positionMode === interface_1.OrderPositionMode.BUYSELL) {
            _position = positions[0];
        }
        else {
            // 获取当前仓位跟反向仓位
            _position = positions.find((it) => it.position_side === positionSide);
            const reverseSide = positionSide === interface_1.FuturePositionSide.LONG ? interface_1.FuturePositionSide.SHORT : interface_1.FuturePositionSide.LONG;
            _rPosition = positions.find((it) => it.position_side === reverseSide);
        }
        return { position: _position, rPosition: _rPosition };
    },
    getMaxCanBuy(params) {
        const { leverage, reversePosition, tradedMargin, tradePrice, reduceOnly, investSide, positionMode, investPrecision, orderType } = params;
        const leverD = new trade_utils_lib_1.SafeDecimal(leverage);
        // 反向仓位绝对值
        const reversePositionABS = new trade_utils_lib_1.SafeDecimal(reversePosition).abs();
        // 计算可买
        let cb = "";
        let cbDisplay = "";
        const tradePriceD = new trade_utils_lib_1.SafeDecimal(tradePrice);
        /** 平仓后的保证金可投金额： 保证金 * 杠杆倍数，最小值为0 */
        const availInvestD = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(tradedMargin).mul(leverD), 0);
        /** 反向仓位可投的quote */
        const positionCanCost = reversePositionABS.mul(tradePriceD);
        /** 保证金可买的base */
        const marginCB = availInvestD.div(tradePriceD);
        if (reduceOnly) {
            if (investSide === interface_1.InvestSymbolSide.base) {
                if (positionMode === interface_1.OrderPositionMode.BUYSELL) {
                    cb = "";
                }
                else {
                    cb = reversePositionABS.eq(0) ? "0" : "";
                }
                cbDisplay = reversePositionABS.toString();
            }
            else {
                cbDisplay = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(positionCanCost, investPrecision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
                if (positionMode === interface_1.OrderPositionMode.BUYSELL) {
                    cb = "";
                }
                else {
                    cb = new trade_utils_lib_1.SafeDecimal(cbDisplay).eq(0) ? "0" : "";
                }
            }
        }
        else if (tradePriceD.equals(0) === false) {
            // 限价单
            if (CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType)) {
                if (investSide === interface_1.InvestSymbolSide.base) {
                    // 保证金可买 + 反向持仓量
                    cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(marginCB.add(reversePositionABS), investPrecision);
                    cbDisplay = cb;
                }
                else {
                    // 可投 反向持仓价值 + 乘以杠杆倍数的可投金额
                    cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(positionCanCost.add(availInvestD), investPrecision);
                    cbDisplay = cb;
                }
            }
            else if (CalculateUtils_1.CalculateUtils.isFuturesMarket(orderType)) {
                // 市价单保证金冗余
                const marketMarginOffset = 0.95;
                // 市价单
                if (investSide === interface_1.InvestSymbolSide.base) {
                    cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(marginCB.add(reversePositionABS), investPrecision);
                    // 保证金可买 * 冗余 + 反向持仓量
                    cbDisplay = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(marginCB.mul(marketMarginOffset).add(reversePositionABS), investPrecision);
                }
                else {
                    // 反向持仓价值 + 可投金额
                    cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(positionCanCost.add(availInvestD), investPrecision);
                    // 反向持仓价值 * 冗余 + 可投金额
                    cbDisplay = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(positionCanCost.mul(marketMarginOffset).add(availInvestD), investPrecision);
                }
            }
        }
        return [cb, cbDisplay, availInvestD.toString()];
    },
    /**传入当前仓位并判断该仓位是否满足反向仓位的逻辑，以及是否支持选择Reduce only */
    getPositionReverseQty(positionMode, orderSide, reduceOnly, position) {
        // 双向仓位开仓时不考虑反向仓位，只有在平仓时需要考虑反向仓位
        if (positionMode === interface_1.OrderPositionMode.OPENCLOSE) {
            if (!reduceOnly) {
                return [new trade_utils_lib_1.SafeDecimal(0), false];
            }
        }
        let rP = new trade_utils_lib_1.SafeDecimal(0);
        const positionQty = new trade_utils_lib_1.SafeDecimal(position === null || position === void 0 ? void 0 : position.positionQuantity);
        if (orderSide === interface_1.CustomOrderSide.BUY) {
            if (positionQty.lessThan(0)) {
                rP = positionQty;
            }
        }
        else {
            if (positionQty.greaterThan(0)) {
                rP = positionQty;
            }
        }
        const _enableReduce = !rP.equals(0);
        return [rP, _enableReduce];
    },
};
